import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { HttpApiClient } from "../../axios/axiosInstance";
import { createPackage, fetchPackages, updatePackage } from "../../services";

const initialState = {
  packages: [],
  packagesLoading: false,
  packagesFetchingError: null,
  createArtistPackageLoading: false,
  createArtistPackageError: null,
};

export const fetchArtistPackage = createAsyncThunk(
  "package/fetchArtistPackage",
  async (request) => {
    const response = await HttpApiClient.get(
      `${fetchPackages}/${request.artistUsername}`
    );
    return response.data;
  }
);

export const createArtistPackage = createAsyncThunk(
  "package/createArtistPackage",
  async (request) => {
    const response = await HttpApiClient.post(createPackage, request);
    return response.data;
  }
);

export const updateArtistPackage = createAsyncThunk(
  "package/updateArtistPackage",
  async (request) => {
    const response = await HttpApiClient.put(
      `${updatePackage}/${request.packageId}`,
      request
    );
    return response.data;
  }
);

export const deleteArtistPackage = createAsyncThunk(
  "package/deleteArtistPackage",
  async (request) => {
    const response = await HttpApiClient.delete(
      `${updatePackage}/${request.packageId}`,
      request
    );
    return response.data;
  }
);

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArtistPackage.pending, (state) => {
        state.packagesLoading = true;
        state.error = null;
      })
      .addCase(fetchArtistPackage.fulfilled, (state, action) => {
        state.packagesLoading = false;
        state.packages = action.payload.data;
      })
      .addCase(fetchArtistPackage.rejected, (state, action) => {
        state.packagesLoading = false;
        state.packagesFetchingError = action.error.message;
      })

      .addCase(createArtistPackage.pending, (state) => {
        state.createArtistPackageLoading = true;
        state.createArtistPackageError = null;
      })
      .addCase(createArtistPackage.fulfilled, (state, action) => {
        state.createArtistPackageLoading = false;
      })
      .addCase(createArtistPackage.rejected, (state, action) => {
        state.createArtistPackageLoading = false;
        state.createArtistPackageError = action.error.message;
      });
  },
});

export default packageSlice.reducer;
